import { Directive, effect, inject, input } from '@angular/core';
import { booleanAttribute } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({ selector: '[appCanAutoFocus]' })
export class CanAutoFocusDirective {
  private readonly _matSelect = inject(MatSelect, { optional: true });

  public readonly canAutoFocus = input(false, {
    alias: 'appCanAutoFocus',
    transform: (value: unknown) => booleanAttribute(value),
  });

  constructor() {
    effect(() => {
      if (!this.canAutoFocus()) return;

      queueMicrotask(() => {
        if (this._matSelect) {
          this._matSelect.focus();
          return;
        }
      });
    });
  }
}
